'use client';

import { ROUTES, meta } from '#/data/constants';
import Image from 'next/image';
import Link from 'next/link';
import { useLocale } from '#/i18n/client';
import { localizePath } from '#/i18n/config';
import { useT } from '#/i18n/client';

export default function BiComponent() {
  const locale = useLocale();
  const en = locale === 'en';
  const t = useT('common');
  return (
    <div className="cursor-pointer">
      <Link className="sr-only" href={localizePath(ROUTES.ANALYZE, locale)}>
        {en ? 'Morphological Analysis' : '형태소 분석'}
      </Link>
      <Link className="sr-only" href={localizePath(ROUTES.TOKENIZE, locale)}>
        {en ? 'Tokenizer' : '단어 분절(토큰나이저)'}
      </Link>

      <Link className="w-8 h-8" href={localizePath(ROUTES.CORRECT, locale)}>
        <span className="sr-only">
          {en ? 'Bareun Spell Checker' : '바른 맞춤법 검사기'}
        </span>
        <Image
          src="/static/images/bareun-logo.webp"
          width={32}
          height={32}
          alt={en ? t('nav.logoAlt') : meta.title}
          priority={true}
        />
      </Link>
    </div>
  );
}
